const pStart = { x: 0, y: 0 };
const pStop = { x: 0, y: 0 };
let contentEl;
let avatar;

function isPullDown(dY, dX) {
  // methods of checking slope, length, direction of line created by swipe action
  return (
    dY < 0
    && ((Math.abs(dX) <= 100 && Math.abs(dY) >= 300)
      || (Math.abs(dX) / Math.abs(dY) <= 0.3 && dY >= 60))
  );
}

function swipeCheck() {
  const changeY = pStart.y - pStop.y;
  const changeX = pStart.x - pStop.x;
  if (isPullDown(changeY, changeX)) {
    setTimeout(() => {
      window.location.reload();
    }, 100);
    contentEl.style.marginTop = 0;
    avatar.style.bottom = 0;
  } else {
    contentEl.style.marginTop = 0;
    avatar.style.bottom = 0;
  }
}

export function swipeStart(e) {
  if (!contentEl) {
    contentEl = document.getElementById('main');
  }
  if (!avatar) {
    // eslint-disable-next-line prefer-destructuring
    avatar = document.getElementById('avatar');
  }
  if (typeof e.targetTouches !== 'undefined') {
    const touch = e.targetTouches[0];
    pStart.x = touch.screenX;
    pStart.y = touch.screenY;
  } else {
    pStart.x = e.screenX;
    pStart.y = e.screenY;
  }
}

export function swipeMove(e) {
  const y = typeof e.targetTouches !== 'undefined' ? e.targetTouches[0].screenY : e.screenY;
  const delta = (y - pStart.y) / 4;
  contentEl.style.marginTop = `${delta}px`;
  if (avatar) {
    avatar.style.bottom = `${-delta}px`;
  }
}

export function swipeEnd(e) {
  if (typeof e.changedTouches !== 'undefined') {
    const touch = e.changedTouches[0];
    pStop.x = touch.screenX;
    pStop.y = touch.screenY;
  } else {
    pStop.x = e.screenX;
    pStop.y = e.screenY;
  }

  swipeCheck();
}
